module.exports = __webpack_public_path__ + "img/3-1.225326c1.jpg";